import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { t } from '../../i18n/translate.js';
import Input from '../../components/Input/Input.js';
import styles from './PetWeight.module.scss.js';

var PetWeight = function PetWeight(_ref) {
  var petWeightController = _ref.petWeightController,
    setNewPetWeightError = _ref.setNewPetWeightError;
  var newPetWeight = petWeightController.newPetWeight,
    setNewPetWeight = petWeightController.setNewPetWeight;
  var weigthHasError = newPetWeight && !(newPetWeight > 0 && newPetWeight <= 35);
  var validateWeight = function validateWeight(val) {
    var onlyDigit = val.replace(/[^\d]/g, '').trim();
    setNewPetWeight(onlyDigit);
  };
  useEffect(function () {
    setNewPetWeightError(weigthHasError);
  }, [newPetWeight]);
  var errormessage = weigthHasError ? t('MPLIB_PET_TYPE_WEIGHT_REQUIREMENT') : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.noborder
  }, /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(val) {
      return validateWeight(val);
    },
    placeholder: t('MPLIB_PET_WEIGHT'),
    value: newPetWeight === '0' || newPetWeight === 0 ? '' : newPetWeight === null || newPetWeight === void 0 ? void 0 : newPetWeight.toString(),
    dataTestId: "petWeightInput",
    minLength: 1,
    maxLength: 2,
    mandatory: true,
    hasError: weigthHasError && (newPetWeight === null || newPetWeight === void 0 ? void 0 : newPetWeight.length) > 0,
    errorMessage: errormessage,
    inputMode: "numeric"
  })));
};
PetWeight.propTypes = {
  petWeightController: PropTypes.shape({
    newPetWeight: PropTypes.string,
    setNewPetWeight: PropTypes.func
  }).isRequired,
  setNewPetWeightError: PropTypes.func.isRequired
};

export { PetWeight as default };
